import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgSearch = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="M5 9.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM9.5 3a6.5 6.5 0 1 0 3.835 11.749l4.958 4.958a1 1 0 0 0 1.414-1.414l-4.958-4.958A6.5 6.5 0 0 0 9.5 3Z" />
  )
export default SvgSearch
